module.exports = __webpack_public_path__ + "img/6.4cf3a163.png";